import React from 'react';
// HashRouter | BrowserRouter
import { BrowserRouter, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import History from './history';

import StoreComponent, { mapStateToProps } from '../appComponents/Store';
import Route from '../appComponents/Route';

import NotFound from '../pages/404';
import Feedback from '../pages/Feedback';
import FeedSuccess from '../pages/Feedback/FeedSuccess';
import FeedHistory from '../pages/Feedback/History';
import FeedUpload from '../pages/Feedback/Upload';

// CRM企微端页面
import CRMFeedbackList from '../pages/CRM/Feedback/List';
import CRMFeedbackDetail from '../pages/CRM/Feedback/Detail';
import Reply from '../pages/Feedback/Reply';
import More from '../pages/Feedback/Reply/History';

// iPad版本
import IpadVersion from '../pages/IpadVersion';

class Component extends StoreComponent {
  render(): React.ReactNode {
    return (
      <BrowserRouter basename={'/'}>
        <History>
          <Switch>
            <Route path={'/feedback'} exact component={Feedback} isLogin={true} appVersion="4.5.2"/>
            <Route path={'/feedback/success'} exact component={FeedSuccess}/>
            <Route path={'/feedback/history'} exact component={FeedHistory} isLogin={true}/>
            <Route path={'/upload'} exact component={FeedUpload}/>
            <Route path={'/feedback/reply/:feedbackNo'} exact component={Reply} />
            <Route path={'/feedback/historyMore'} exact component={More}/>

            {/* CRM企微端业务 */}
            <Route path={'/crm/feedback/list'} exact component={CRMFeedbackList} />
            <Route path={'/crm/feedback/detail/:feedbackNo'} exact component={CRMFeedbackDetail} />

            {/* iPad版本管理 */}
            <Route path={'/ipad/version'} exact component={IpadVersion} isLogin={false} />

            <Route path={'*'} component={NotFound}/>
          </Switch>
        </History>
      </BrowserRouter>
    );
  }
}

export default connect(mapStateToProps)(Component);
